export default "__VITE_ASSET__BrPw3KeR__"